/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PitchBasicRequest } from './pitch-basic-request';
import { UserRequest } from './user-request';

export interface PatchedDeckPitchesSubscriptionRequest {
  user?: UserRequest;
  pitch?: PitchBasicRequest;
  subscribed?: boolean;
}
